import {
  CLEAR_STATE,
  GET_DASHBOARD_LIST,
  GET_SETUP_CONFIG,
  SET_ID_DATES,
  SET_INITIAL_SETUP_DONE,
  SET_ID_PRINTING,
  SET_SELECTED_DASHBOARD,
  SET_SETUP,
  SET_SETUP_CONFIG,
  SET_SETUP_KEY,
  SET_SHOW_PUBLICATIONS_FILTER,
  SET_SHOW_TRENDS,
} from "./insightsDashboardTypes";
import { InsightsDashboardSetup, InsightsDashboardSetupConfig } from "./types";
import { API_URLS } from "src/utils/API_URLS";
import { SocialInsightsDashboardListElement } from "./utils";
import { IDDateRangeOption } from "src/app/components/InsightsDashboard/InsightsDashboard";

export const setSetup = (setup: InsightsDashboardSetup) => {
  return {
    type: SET_SETUP,
    payload: {
      setup,
    },
  };
};

export const setSetupKey = (key: keyof InsightsDashboardSetup, value: any) => {
  return {
    type: SET_SETUP_KEY,
    payload: {
      key,
      value,
    },
  };
};

export const clearInsightsDashboardState = () => {
  return {
    type: CLEAR_STATE,
  };
};

export const setInitialSetupDone = () => {
  return {
    type: SET_INITIAL_SETUP_DONE,
  };
};

export const setShowTrends = (showTrends: boolean) => {
  return {
    type: SET_SHOW_TRENDS,
    payload: {
      showTrends,
    },
  };
};

export const setSetupConfig = (setupConfig: InsightsDashboardSetupConfig) => {
  return {
    type: SET_SETUP_CONFIG,
    payload: {
      setupConfig,
    },
  };
};

export const setShowPublicationsFilter = (showPublicationsFilter: boolean) => {
  return {
    type: SET_SHOW_PUBLICATIONS_FILTER,
    payload: {
      showPublicationsFilter,
    },
  };
};

export const getDashboardList = (workspaceUuid: string) => {
  const url = API_URLS.getInsightsDashboardList.replace(
    ":workspaceUuid:",
    workspaceUuid,
  );

  return {
    type: GET_DASHBOARD_LIST,
    payload: {
      request: { url },
    },
  };
};

export const setSelectedDashboard = (
  dashboard: SocialInsightsDashboardListElement | null,
) => {
  return {
    type: SET_SELECTED_DASHBOARD,
    payload: {
      dashboard,
    },
  };
};

export const getSetupConfig = (workspaceUuid: string) => {
  const url = API_URLS.getSocialInsightsSettingsData.replace(
    ":workspaceUuid:",
    workspaceUuid,
  );

  return {
    type: GET_SETUP_CONFIG,
    payload: {
      request: { url },
    },
  };
};

export const setIDDates = ({
  dateFrom,
  dateTo,
  dateRange,
}: {
  dateFrom?: string | null;
  dateTo?: string | null;
  dateRange?: IDDateRangeOption | null;
}) => {
  const payload = Object.fromEntries(
    Object.entries({ dateFrom, dateTo, dateRange }).filter(
      ([, value]) => value !== undefined,
    ),
  );

  return {
    type: SET_ID_DATES,
    payload,
  };
};

export const setIDPrinting = (printing: boolean) => {
  return {
    type: SET_ID_PRINTING,
    payload: { printing },
  };
};
